import NestShieldColor from './NestShieldColour.svg';
import NestShieldDark from './NestShieldDark.svg';
import NestShieldLight from './NestShieldLight.svg';
export const nestShield = { color: NestShieldColor, dark: NestShieldDark, light: NestShieldLight };
//# sourceMappingURL=index.js.map